import type { CSSVariablesResolver } from "@mantine/core";
import { MantineFormCssResolver } from "@ngt-form/mantine";

import { applicationContainerSizes } from "./layoutSizes";

/**
 * Extends form-library CSS variables with readable disabled text and shared container widths.
 * Postconditions: Returns the base resolver object after mutating both color schemes and root variables.
 * Assumptions: The form resolver supplies mutable light, dark and variables maps; failures propagate.
 */
export const mantineCssResolver: CSSVariablesResolver = theme => {
    const resolver = MantineFormCssResolver(theme);

    resolver.light["--mantine-color-disabled-color"] = "var(--mantine-color-text)";
    resolver.dark["--mantine-color-disabled-color"] = "var(--mantine-color-text)";
    resolver.variables["--tmd-container-size-xs"] = applicationContainerSizes.xs;
    resolver.variables["--tmd-container-size-sm"] = applicationContainerSizes.sm;
    resolver.variables["--tmd-container-size-md"] = applicationContainerSizes.md;
    resolver.variables["--tmd-container-size-lg"] = applicationContainerSizes.lg;
    resolver.variables["--tmd-container-size-xl"] = applicationContainerSizes.xl;

    return resolver;
};
